import { Html } from '@react-three/drei';
import { ControlContext } from 'provider/ControlProvider';
import ReactPlayer from 'react-player';
import { useContext, useEffect, useRef } from 'react';
import { gsap } from 'gsap';

type Props = {
  name?: string;
  pos?: Array<number>;
  url?: string;
};

const ScreenVideo = ({
  name = 'Unknown',
  pos = [0, 0.1, 0],
  url = '/video/adver.mp4',
}: Props) => {
  const { controlStatus, end, setEnd, prepare, setPrepare } =
    useContext(ControlContext);
  const content = useRef<any>();
  const playerContent = useRef<any>();
  const slideEffect = () => {
    gsap.to(content.current, {
      duration: 3,
      ease: 'power1.out',
      opacity: 0,
      onComplete: () => {
        setEnd(true);
      },
    });
    gsap.to(playerContent.current, {
      duration: 2,
      ease: 'power1.out',
      opacity: 0,
      onComplete: () => {
        setEnd(true);
      },
    });
  };
  useEffect(() => {
    if (prepare) slideEffect();
  }, [prepare]);

  return end ? null : (
    <div className='bg-black'>
      <div
        ref={playerContent}
        className='bg-black w-screen h-screen ios absolute z-40 flex flex-col items-center justify-center'
      >
        <ReactPlayer
          playing={controlStatus}
          muted={true}
          url={url}
          width={'130%'}
          height={'130%'}
          onEnded={() => setPrepare(true)}
        />
      </div>
    </div>
  );
};

export default ScreenVideo;
